module.exports = __webpack_public_path__ + "img/22.bd9e8f1a.png";